import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { Section } from '../../../../components/ui/Section';
import { TableHeader } from '../../../../components/forms/TableHeader';
import { Pill } from '../../../../components/shared/Pill';
import { CatalogueGovernanceClient, GovernanceIssueRow } from '../../../../app/services/api/catalogueGovernance';
import SeverityChip from './SeverityChip';

const OverviewTab = () => {
  const { t } = useTranslation('catalogueGovernance');
  const [issues, setIssues] = useState<GovernanceIssueRow[]>([]);

  useEffect(() => {
    CatalogueGovernanceClient.getIssues().then(setIssues);
  }, []);

  return (
    <Box>
      <Section>
        <TableHeader>
          {t('overview.tableTitle', 'Governance issues')}
          <Pill text={t('overview.issueCount', '{{count}} issues', { count: issues.length })} />
        </TableHeader>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>{t('overview.columnIssue', 'Issue')}</TableCell>
                <TableCell>{t('overview.columnSupplier', 'Supplier')}</TableCell>
                <TableCell>{t('overview.columnCatalogue', 'Catalogue')}</TableCell>
                <TableCell>{t('overview.columnProduct', 'Product')}</TableCell>
                <TableCell>{t('overview.columnSeverity', 'Severity')}</TableCell>
                <TableCell>{t('overview.columnAffectedSites', 'Affected sites')}</TableCell>
                <TableCell>{t('overview.columnOwner', 'Owner')}</TableCell>
                <TableCell>{t('overview.columnStatus', 'Status')}</TableCell>
                <TableCell>{t('overview.columnDueDate', 'Due date')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {issues.length === 0 && (
                <TableRow><TableCell colSpan={9}>{t('overview.emptyState', 'No governance issues to show.')}</TableCell></TableRow>
              )}
              {issues.map((row) => (
                <TableRow key={row.id}>
                  <TableCell>{row.issue}</TableCell>
                  <TableCell>{row.supplier}</TableCell>
                  <TableCell>{row.catalogue}</TableCell>
                  <TableCell>{row.product}</TableCell>
                  <TableCell><SeverityChip severity={row.severity} /></TableCell>
                  <TableCell>{row.affectedSites}</TableCell>
                  <TableCell>{row.owner}</TableCell>
                  <TableCell>{row.status}</TableCell>
                  <TableCell>{row.dueDate}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Section>
    </Box>
  );
};

export default OverviewTab;
